var exports = {
  "Np": "xe564cbfb--ab7fa0--fallback",
  "kL": "xe564cbfb--ab7fa0--container",
  "Qs": "xe564cbfb--ab7fa0--content",
  "x6": "xe564cbfb--ab7fa0--button",
};

module.exports = exports;
